export default "__VITE_ASSET__DpUdsrgw__"